module.exports = __webpack_public_path__ + "static/media/crossroads.16e96fea.png";